import { usePostFetch } from '../utils/reactQuery';
import { pathToUrl } from '../utils/router';
import { ApiRoutesEnum } from '../utils/routes';

import { UserType } from './types';

export type FetchUsersResponseType = {
  count: number;
  results: UserType[];
};

export const useGetAllUsers = () =>
  usePostFetch<FetchUsersResponseType>(pathToUrl(ApiRoutesEnum.searchUsers), { criteria: [], max: 10000 });
